export default {
  Title: 'Travel Preferences',
  Subtitle: 'What\'s your preferred way to travel to assignments and maximum travel time?',
  TransportationMethodTitle: 'Transportation Method',
  TransportationMethodDescription: 'Select your preferred transportation method',
  MaxTravelTimeTitle: 'Maximum Travel Time',
  TransportModes: {
    Car: {
      Label: 'Car',
      Description: 'Drive to assignments',
    },
    Transit: {
      Label: 'Transit',
      Description: 'Public transportation',
    },
    Cycling: {
      Label: 'Cycling',
      Description: 'Bike to assignments',
    },
    Walking: {
      Label: 'Walking',
      Description: 'Walk to nearby assignments',
    },
  },
  TimeMarks: {
    FiveMin: '5 min',
    ThirtyMin: '30 min',
    OneHour: '1 hour',
  },
  TimeFormats: {
    OneHour: '1 hour',
    Minutes: '#{minutes} minutes',
  },
  ImportantInfo: {
    Title: 'Important Info',
    Message: 'All shifts are a minimum of 2 hours. Your travel time preference helps us match you with the right clients in your area.',
  },
  Summary: {
    Title: 'Your Travel Preferences',
    MaxLabel: '#{time} max',
  },
  EstimateTitle: 'Travel Range Estimate',
  EstimateDisclaimer: 'This is only an estimate. Actual travel times and distances may vary due to traffic, route, and other factors.',
  MapClickInstruction: 'Click the map to set your location',
};
